module.exports = __webpack_public_path__ + "static/media/modis2980.fb226dbb.jpg";